export var TranslationNamespace;
(function (TranslationNamespace) {
    TranslationNamespace["TRANSLATION"] = "translation";
    TranslationNamespace["COMMON"] = "common";
    TranslationNamespace["NAVBAR"] = "navbar";
    TranslationNamespace["DATE_PICKER"] = "date-picker";
    TranslationNamespace["WORK_EXPERIENCE"] = "work-experience";
    TranslationNamespace["PERSON_INTERVIEW"] = "person-interview";
    TranslationNamespace["CUSTOM_TEMPLATE"] = "custom-template";
})(TranslationNamespace || (TranslationNamespace = {}));
//# sourceMappingURL=index.js.map